import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { PrimaryButtonProps } from 'src/components/common/ui/button/button';
import { getSearchToolsQueryParams, QueryParamsStrategies } from '@shared-utils/search-tools-query-params-mapper';

//helpers
import {
  formatDateWithLang,
  getDateFormatWithLang,
  getLocalizationData,
  getWizardUrlOverrideURL,
  getWizOverrideDateParaName,
  linkTabOpenner,
  renderInvalidTypeheadStyles,
  getWizardDefaults,
  WizardDefaultProps,
  getWizardsOverrides,
  wizardDate,
  getValidReturnDate,
} from '../../helpers';
import { UitkButtonSize } from 'uitk-react-button';
import { checkValue } from 'src/components/common/helper';
import { useStores } from 'src/utils/useStore';
import { sendSearchWizardSearchGTMEvent } from 'src/components/common/utils/gtmHelperFunctions';
import { FlightUitkSideRailView, FlightUitkStandardView } from './views';
import { localization } from 'src/components/common/helper';
//import tr from 'date-fns/esm/locale/tr/index.js';

export enum ViewTypes {
  STANDARD,
  SIDERAIL
};

// interface CurrentValues {
//   noAdults: number;
//   noChildren: number;
//   addHotelSearch: boolean;
// }

export const FlightUitk: React.FC<any> = ({ localizationData, device, data, mccidData, isAdvanced, setSearchFilters }) => {
  const { context } = useStores();
  const isHotelsCom = context?.site?.brand === 'hotels';
  const searchdDateFormat = getDateFormatWithLang(context?.locale, context?.localDateFormat);

  const today = new Date();
  const dayAfterTwoWeeks = new Date();
  const nextDayAfterDayAfterTwoWeeks = new Date();
  dayAfterTwoWeeks.setDate(today.getDate() + 14);
  nextDayAfterDayAfterTwoWeeks.setDate(today.getDate() + 15);

  // Check the default data is coming from the searchOverride if so
  // Get the code
  const wizardDefault: WizardDefaultProps = {
    data,
    lob: 'Flight',
    overrideController: 'returnDefault',
  };
  const wizardOverrideDefault = getWizardDefaults(wizardDefault);
  let returnDefault = '';
  if (checkValue(wizardOverrideDefault, true)) {
    const getReturn = wizardOverrideDefault?.find((w) => w.key === 'returnDefault');
    if (checkValue(getReturn) && checkValue(getReturn.value)) {
      returnDefault = getReturn?.value;
    }
  } else {
    returnDefault = get(data, 'returnDefault', '');
  }

  // Get Wizard Overrides Date
  const wizardOverrides = getWizardsOverrides(data, 'Flight');
  let wizardOverridesDepartureDate = '';
  let wizardOverridesReturnDate = '';
  if (checkValue(wizardOverrides, true)) {
    wizardOverridesDepartureDate = wizardOverrides?.[0]?.dateFrom;
    wizardOverridesReturnDate = wizardOverrides?.[0]?.dateTo;
  }
  const departureDate = wizardDate(
    get(data, 'departureDate', ''),
    get(data, 'departureDateFixed', ''),
    wizardOverridesDepartureDate,
    dayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    ''
  );
  const returnDatewizardDate = wizardDate(
    get(data, 'returnDate', ''),
    get(data, 'returnDateFixed', ''),
    wizardOverridesReturnDate,
    nextDayAfterDayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    get(data, 'lengthOfStay', '')
  );
  const returnDate = getValidReturnDate(departureDate, returnDatewizardDate);

  const travelerMaxErrorText =  getLocalizationData(localizationData, 'select_traveler', 'The traveler count exceeds the maximum allowed for packges searches.', device);

  //init state
  const initFormState = {
    leavingFrom: { value: get(data, 'departureDefault', ''), error: '', typeHeadId: 'textFlightFrom' },
    goingTo: { value: returnDefault, error: '', typeHeadId: 'textFlightGoing' },
    departureDate: {
      value: departureDate,
      error: '',
    },
    returnDate: {
      value: returnDate,
      error: '',
    },
    addHotel: {
      value: false,
      error: '',
    },
    traveler: {
      value: 0,
      error: ''     
    },
    showRoom: false,
  };

  //formstate handle
  const [formState, setFormState] = useState(initFormState);

  const isTravelerError = false;

  //onChangeHandler
  const onChangeHandler = (state, value, error = '') => {
    setFormState((prev) => ({
      ...prev,
      [state]: {
        ...prev?.[state],
        value,
        error
      },
    }));
  };

  //handle validations
  const handleValidations = () => {
    let isValidate = true;
    let fromError = '';
    let goingToError = '';
    let travelerError = '';

    if (formState?.leavingFrom?.value === '') {
      isValidate = false;
      fromError = getLocalizationData(localizationData, 'select_origin', 'Please select an origin', device);
    }

    if (formState?.goingTo?.value === '') {
      isValidate = false;
      goingToError = getLocalizationData(localizationData, 'select_destination', 'Please select a destination', device);
    }
    
    if (formState?.addHotel?.value && ((formState?.traveler?.value) > 6)) {
      isValidate = false;
      travelerError = travelerMaxErrorText;
    }

    setFormState((prev) => ({
      ...prev,
      leavingFrom: { ...prev?.leavingFrom, error: fromError },
      goingTo: { ...prev?.goingTo, error: goingToError },
      traveler: { ...prev?.traveler, error: travelerError }
    }));

    return isValidate;
  };

  const updateTypeaheadFrom = (selectedValue) => {
    onChangeHandler('leavingFrom', selectedValue);
  };
  const updateTypeaheadto = (selectedValue) => {
    onChangeHandler('goingTo', selectedValue);
  };
  // TODO: need refactor
  const updatePackageCheckBox = (_: string, e: React.ChangeEvent<HTMLInputElement>) => {
    let travelerError = ''
    if (e?.target?.checked && ((formState?.traveler?.value) > 6)) {
      travelerError = travelerMaxErrorText;
    }
    setFormState((prev) => ({
      ...prev,
      traveler: { ...prev?.traveler, error: travelerError }
    }));
    onChangeHandler('addHotel', e?.target?.checked);
  };
  // TODO: need refactor
  const updateTavelerCount = (count: number) => {
    let travelerError = ''
    if (formState?.addHotel?.value && ((count) > 6)) {
      travelerError = travelerMaxErrorText;
    }
    onChangeHandler('traveler', count, travelerError);
  }
  const updateDates = (startDate, endDate) => {
    console.log(startDate, endDate);
  };

  const primaryButtonProps: PrimaryButtonProps = {
    text: getLocalizationData(localizationData, 'search_button_copy', 'Search', device),
    tag: 'button',
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Featured Content',
      eventLabel: `${getLocalizationData(localizationData, 'search_button_copy', 'Search', device)} - ${'cTALink'}`,
    },
    exClass: `btn mobile-btn`,
    target: '_blank',
    size: UitkButtonSize.LARGE,
  };

  const getFlightOverWrides = (flightOverrideURL, overridePara, paraName, userValue) => {
    let url = flightOverrideURL;
    if (!flightOverrideURL.includes('http://www.')) {
      url = new URL('http://www.expedia.com' + url);
    }
    let paraValue = url.searchParams.get(overridePara);
    if (paraValue === null) {
      paraValue = userValue;
    }
    return paraName + ':' + paraValue;
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isTravelerError) {
      if (handleValidations()) {
        const { elements } = event.currentTarget;
        const inputs = Array.from(elements) as HTMLInputElement[];
        let leg2departureDate = '';
        let leg2originDate = '';
        let leg2origin = '';
        let leg2destination = '';
        let searchURL = '';
        let leg2adults = '';
        let leg2childrenAges = '';
        let leg2children = '';
        let leg2AddHotelSearch = false;

        inputs.forEach((input) => {
          const inputVal: string = checkValue(input.value) ? input.value : '';

          if (input.name === 'EGDSDateRangePicker-StartDate-date_form_field') {
            leg2originDate = inputVal;
          }
          if (input.name === 'EGDSDateRangePicker-EndDate-date_form_field') {
            leg2departureDate = inputVal;
          }
          if (input.name === 'EGDSSearchFormLocationField-Location-destination_select') {
            leg2destination = inputVal;
          }
          if (input.name === 'EGDSSearchFormLocationField-Location-origin_select') {
            leg2origin = inputVal;
          }
          if (input.name === 'traveler-adults') {
            leg2adults = inputVal;
          }
          if (input.name === 'traveler-children' && inputVal !== '') {
            leg2childrenAges = inputVal;
            leg2children = inputVal?.split(',')?.length?.toString();
          }
          if (input.name === 'side-rail-addHotel-checkbox') {
            leg2AddHotelSearch = input.checked;
          }
        });

        

        if (data?.view === ViewTypes.SIDERAIL) {
          const dates = formatDateWithLang(context?.locale, leg2originDate).date.split(' - ');
          const childrenAges: any = checkValue(leg2childrenAges) ? leg2childrenAges?.split(',') : '';
          if (checkValue(dates, true) && dates.length > 1) {
            if (leg2AddHotelSearch) {
              const searchUrl = `/go/package/search/FlightHotel/${localization.formatDateString(dates?.[0], {
                skeleton: 'yyyy-MM-dd',
              })}/${localization.formatDateString(dates?.[1], { skeleton: 'yyyy-MM-dd' })}`;
              const searchParams = new URLSearchParams();
              searchParams.set('FromAirport', leg2origin);
              searchParams.set('Destination', leg2destination);
              checkValue(leg2adults) && searchParams.set('NumAdult', leg2adults);
              checkValue(leg2children) && searchParams.set('NumChild', leg2children);
              checkValue(childrenAges, true) && childrenAges.map((el: any, inx: number) => searchParams.set(`Child${inx + 1}Age`, el));
              searchParams.set('NumRoom', "1");
              searchParams.set('NumAdult-Room1', "1");
              linkTabOpenner(`${searchUrl}?${searchParams.toString()}`, mccidData); 
            } else {
              // const searchUrl = `/go/flight/search/RoundTrip/${localization.formatDateString(dates?.[0], {
              //   skeleton: 'yyyy-MM-dd',
              // })}/${localization.formatDateString(dates?.[1], { skeleton: 'yyyy-MM-dd' })}`;
              // const searchParams = new URLSearchParams();
              // searchParams.set('FromAirport', leg2origin);
              // searchParams.set('ToAirport', leg2destination);
              // checkValue(leg2adults) && searchParams.set('NumAdult', leg2adults);
              // checkValue(leg2children) && searchParams.set('NumChild', leg2children);
              // checkValue(childrenAges, true) && childrenAges.map((el: any, inx: number) => searchParams.set(`Child${inx + 1}Age`, el));
              // linkTabOpenner(`${searchUrl}?${searchParams.toString()}`, mccidData);

              let queryParams = getSearchToolsQueryParams(QueryParamsStrategies.FLIGHTS, inputs);             
              // Replace fromDate
              const fromDateRegex = /fromDate=.*?(&|$)/;
              queryParams = queryParams.replace(fromDateRegex, `fromDate=${dates?.[0]}$1`); 
              
              const leg1Regex = /&leg1=.*?(&|$)/;
              queryParams = queryParams.replace(leg1Regex, '$1');
              queryParams = queryParams + '&leg1=from:' + leg2origin;
              queryParams = queryParams + ',to:' + leg2destination;
              queryParams = queryParams + ',departure:' + dates?.[0];
              
              queryParams = queryParams?.replace('adults:0', `adults:${checkValue(leg2adults) ? leg2adults : 1}`);  
                
              if(checkValue(leg2children) && checkValue(childrenAges, true)){                
                queryParams = queryParams?.replace('children:0', `children:${leg2children}[${childrenAges.join(';')}]`);  
              }              
              queryParams = queryParams + '&trip=roundtrip';
              queryParams = queryParams + '&leg2=from:' + leg2origin;
              queryParams = queryParams + ',to:' + leg2destination;
              queryParams = queryParams + ',departure:' + dates?.[1];
             
              searchURL = `/Flights-Search${queryParams}`;              
              linkTabOpenner(`${searchURL}`, mccidData);
            }
            return;
          }
          return;
        }



        if (isHotelsCom) {
          const flightOverrideURL = getWizardUrlOverrideURL(
            'Flight',
            'https://travel.hotels.com/Flights-Search?',
            data?.wizardUrlOverride
          );

          searchURL =
            flightOverrideURL +
            getWizOverrideDateParaName('Flight', 'dateFrom', 'DATEFROM', 'starDate', data?.wizardUrlOverride) +
            '=' +
            formatDateWithLang(context?.locale, leg2originDate).date +
            '&' +
            getWizOverrideDateParaName('Flight', 'dateTo', 'DATETO', 'endDate', data?.wizardUrlOverride) +
            '=' +
            formatDateWithLang(context?.locale, leg2departureDate).date +
            '&mode=search&trip=roundtrip' +
            '&leg1=' +
            getFlightOverWrides(flightOverrideURL, 'FromAirport', 'from', leg2origin) +
            ',' +
            ',' +
            getFlightOverWrides(flightOverrideURL, 'Destination', 'to', leg2destination) +
            ',' +
            ',' +
            'departure:' +
            formatDateWithLang(context?.locale, leg2originDate).date +
            'TANYT' +
            '&leg2=' +
            getFlightOverWrides(flightOverrideURL, 'Destination', 'from', leg2destination) +
            ',' +
            ',' +
            getFlightOverWrides(flightOverrideURL, 'FromAirport', 'to', leg2origin) +
            ',' +
            'departure:' +
            formatDateWithLang(context?.locale, leg2departureDate).date +
            'TANYT' +
            '&passengers=children:0,adults:1' +
            ',seniors:0,infantinlap:Y';
        } else {
          if (checkValue(data?.wizardUrlOverride, true)) {
            const objURL = data?.wizardUrlOverride?.filter((item) => item.wizardTab === 'Flight');
            if (checkValue(objURL?.[0])) {
              const flightOverrideURL = getWizardUrlOverrideURL('Flight', '/Flights-Search?', data?.wizardUrlOverride);
              searchURL =
                flightOverrideURL +
                'trip=roundtrip&leg1=' +
                getFlightOverWrides(flightOverrideURL, 'FromAirport', 'from', leg2origin) +
                ',' +
                getFlightOverWrides(flightOverrideURL, 'Destination', 'to', leg2destination) +
                ',' +
                'departure:' +
                formatDateWithLang(context?.locale, leg2originDate).date +
                'ANYT&leg2=' +
                getFlightOverWrides(flightOverrideURL, 'Destination', 'from', leg2destination) +
                ',' +
                getFlightOverWrides(flightOverrideURL, 'FromAirport', 'to', leg2origin) +
                ',' +
                'departure:' +
                formatDateWithLang(context?.locale, leg2departureDate).date +
                'TANYT&' +
                'passengers=adults:1' +
                ',children:0,seniors:0,infantinlap:Y&options=cabinclass:economy&mode=search&rfrr=';
            } else {
              let queryParams = getSearchToolsQueryParams(QueryParamsStrategies.FLIGHTS, inputs);

              queryParams = queryParams?.replace('adults:0', 'adults:1');
              queryParams = queryParams + '&trip=roundtrip';
              queryParams = queryParams + '&leg2=from:' + leg2origin;
              queryParams = queryParams + ',to:' + leg2destination;
              queryParams = queryParams + ',departure:' + leg2departureDate;
              searchURL = `/Flights-Search${queryParams}`;
            }
          } else {
            let queryParams = getSearchToolsQueryParams(QueryParamsStrategies.FLIGHTS, inputs);

            queryParams = queryParams?.replace('adults:0', 'adults:1');
            queryParams = queryParams + '&trip=roundtrip';
            queryParams = queryParams + '&leg2=from:' + leg2origin;
            queryParams = queryParams + ',to:' + leg2destination;
            queryParams = queryParams + ',departure:' + leg2departureDate;
            searchURL = `/Flights-Search${queryParams}`;
          }
        }

        if (checkValue(isAdvanced) && isAdvanced === true){
          setSearchFilters({adults: leg2adults, origin: leg2origin, destination: leg2destination, endDate: leg2departureDate, startDate: leg2originDate, children: leg2children, childrenAges: leg2childrenAges, addHotelSearch: leg2AddHotelSearch, type: 'flight', searchURL, mccid: mccidData});
          return;
        }

        const searchParameters =
          leg2originDate + ' - ' + leg2departureDate + '|' + leg2origin + ' - ' + leg2destination;
        sendSearchWizardSearchGTMEvent('wizard_search', 'Flights', searchParameters, searchURL);

        linkTabOpenner(searchURL, mccidData);
      }
    }
  };

  useEffect(() => {
    const errors = Object.keys(formState)
      .map((key) => ({
        error: get(formState, `[${key}].error`, ''),
        typeheadId: get(formState, `[${key}].typeHeadId`, ''),
      }))
      .filter(({ typeheadId }) => typeheadId !== '' && typeheadId !== false && typeheadId !== undefined);
    renderInvalidTypeheadStyles(errors);
  }, [formState]);

  const renderView = () => {
    const moduleProps = {
      formState,
      updateTypeaheadFrom,
      localizationData,
      device,
      updateTypeaheadto,
      updateDates,
      searchdDateFormat,
      primaryButtonProps,
      updatePackageCheckBox,
      travelersOptionalTitle: data?.travelersOptionalTitle,
      updateTavelerCount
    };

    switch (data?.view) {
      case ViewTypes.SIDERAIL:
        return <FlightUitkSideRailView {...moduleProps} />;
      default:
        return <FlightUitkStandardView {...moduleProps} />;
    }
  };
  return (
    <>
      <div className="lodging-wrapper" data-testid="lodging-search-form">
        <form onSubmit={handleSubmit}>{renderView()}</form>
      </div>
    </>
  );
};
